import React, { Fragment, useState } from 'react'
import { formatDbDateWithoutTime } from '../../utils/dateFormater';
import { deleteBlockeEmailAction } from '../../redux/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../loader/loader';
const SingleAdmin = ({ blockEmail, index, totalblockedEmails, user }) => {




    const [showPopup, setShowPopup] = useState(false);
    const [popupHeading, setPopupHeading] = useState("");
    const [popupPara, setPopupPara] = useState("");


    const dispatch = useDispatch()

    const { loading } = useSelector(state => state.inviteUser)


    const displayIndex = String(totalblockedEmails - index).padStart(2, '0');



    const handleDelete = (emailVal) => {



        dispatch(deleteBlockeEmailAction(emailVal));

    }







    return (
        <Fragment>
            {loading && <Loader />}
            <div className="flex w-[150%] lg:w-full py-[1.2vmax] mt-[1vmax] rounded-xl shadow-2 border-l-[0.2vmax] border-indigo-600 items-center bg-white hover:bg-gray-50/50 transition-colors" >
                <div className="text-center flex-center items-center flex-[0.5] text-gray-500 font-bold text-[1.5vmax] lg:text-[0.8vmax]" >
                    #{displayIndex}
                </div>
                <div className="px-[1vmax] flex-[2] text-gray-700 font-semibold text-[1.5vmax] lg:text-[1vmax] flex items-center" >
                    <span className="lowercase">{blockEmail?.email}</span>
                </div>
                <div className="text-center flex-center px-[0.5vmax] flex-[1] text-gray-500 font-medium text-[1.3vmax] lg:text-[0.8vmax]" >
                    {formatDbDateWithoutTime(blockEmail?.created_at)}
                </div>
                {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN") &&
                    <div className="flex-center px-[0.5vmax] flex-[1]" >
                        <button 
                            className="bg-red-50 text-red-600 hover:bg-red-600 hover:text-white p-[0.4vmax_1vmax] rounded-lg text-[1.2vmax] lg:text-[0.8vmax] font-bold transition-all border border-red-100 flex items-center gap-2"
                            onClick={() => {
                                setShowPopup(true)
                                setPopupHeading(`Unblock Email`)
                                setPopupPara(`Are you sure you want to remove '${blockEmail?.email}' from the blacklist?`)
                            }}
                        >
                            <i className="fa-regular fa-trash-can"></i>
                            Unblock
                        </button>
                    </div>
                }
            </div>

            {showPopup &&
                <section className="fixed inset-0 flex justify-center overflow-y-auto bg-[#0000006c] z-[9999999999] p-4">
                    <button className="text-[2.5vmax] text-white fixed top-[2vmax] right-[2vmax]"
                        onClick={() => {
                            setShowPopup(false)
                            setPopupHeading("")
                            setPopupPara("")
                        }}
                    >
                        <div className="fa-solid fa-xmark"></div>
                    </button>
                    <div className="w-full max-w-lg bg-white shadow-lg rounded-[2vmax] h-fit mt-[2vmax] overflow-hidden">
                        <h2 className="text-[1.8vmax] lg:text-[1.4vmax] font-3 font-[900] text-white p-[0.5vmax_3vmax] bg-[var(--secondary)] mb-[1vmax] text-center" >{popupHeading}</h2>
                        <p className='max-w-[33vmax] p-[0vmax_2vmax_2vmax_2vmax] text-gray-600 font-[600] font-3' >
                            {popupPara}
                        </p>
                        <div className="flex justify-end gap-[1vmax] p-[2vmax] pt-0">
                            <button className="text-[1.3vmax] lg:text-[0.9vmax] text-white bg-[image:var(--gradient-3)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => {
                                    setShowPopup(false)
                                    setPopupHeading("")
                                    setPopupPara("")
                                }}
                            >
                                No, Cancel
                            </button>
                            <button className="text-[1.3vmax] lg:text-[0.9vmax] text-white bg-[image:var(--gradient-5)] p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => handleDelete(blockEmail?.email)}
                            >
                                Yes Proceed
                            </button>
                        </div>
                    </div>
                </section>
            }
        </Fragment>
    )
}

export default SingleAdmin
